import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable ,  Subject } from 'rxjs';
import { AppState, runParametricalSelector } from '../../../../../ngrx/state/';
import { IntegrationNames } from '../../../../core/integraition-list';
import * as fromIntegration from '../../../../core/store/integration.reducer';
import { BitbucketCommit } from '../../../models/git-commit';
import * as bitbucketCommit from '../../../store/bitbucket-commit/bitbucket-commit.actions';
import * as fromBitbucketCommit from '../../../store/bitbucket-commit/bitbucket-commit.reducer';

@Component({
  selector: 'bitbucket-task-commit-list',
  templateUrl: './bitbucket-task-commit-list.component.html',
  styleUrls: ['./bitbucket-task-commit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BitbucketTaskCommitComponent implements OnInit, OnDestroy {
  @Input() taskId$: Observable<number>;

  public taskGitCommits$: Observable<BitbucketCommit[]>;
  public isInstalled$: Observable<boolean> = this._store.select(fromIntegration.getIsInstalledBitbucket);
  public name = IntegrationNames.Bitbucket;

  private destroy$ = new Subject();

  constructor(private _store: Store<AppState>) {}

  ngOnInit() {
    this.taskGitCommits$ = runParametricalSelector(
      this._store.select(fromBitbucketCommit.getTaskCommits),
      this.taskId$
    );
  }

  ngOnDestroy() {
    this.destroy$.next();
  }

  onRemove(commit: BitbucketCommit) {
    this._store.dispatch(new bitbucketCommit.DeleteTaskCommit({ id: commit.id, taskId: commit.task }));
  }
}
